import * as types from '../constant/actionTypes';

const initialState = {
  isAuth: false,
  // isAuth: true,
  userToken: '',
  errMsg: '',
  companyName: '',
  loading: false,
  dateList: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
  case types.AUTH_USER:
  case types.USER_LOGIN_API_SUCCESS:
    return {
      ...state,
      isAuth: true,
      loading: false,
      userToken: `Bearer ${action.payload.token}`,
      company: action.payload.company,
    };
  case types.SET_ERR_MSG:
    return {
      ...state,
      errMsg: action.payload,
    };
  case types.RESET_ERR_MSG:
    return {
      ...state,
      errMsg: '',
    };
  case types.DATE_LIST_API_SUCCESS: {
    return {
      ...state,
      dateList: action.payload,
      loading: false,
    };
  }
  case types.SYMBOL_SUMMARY_PAGE_API_ERROR:
  case types.SYMBOL_SUMMARY_SYMBOL_DETAIL_ERROR:
  case types.PERFORMANCE_PAGE_API_ERROR:
  case types.ADJUSTMENT_PAGE_API_ERROR:
  case types.PREDICTION_PAGE_API_ERROR:
  case types.USER_LOGIN_API_ERROR:
  case types.DATE_LIST_API_ERROR:
    return {
      ...state,
      errMsg: action.payload.msg,
      loading: false,
    };
  case types.SYMBOL_SUMMARY_PAGE_API_REQUEST:
  case types.SYMBOL_SUMMARY_SYMBOL_DETAIL_REQUEST:
  case types.PERFORMANCE_PAGE_API_REQUEST:
  case types.ADJUSTMENT_PAGE_API_REQUEST:
  case types.PREDICTION_PAGE_API_REQUEST:
  case types.USER_LOGIN_API_REQUEST:
  case types.DATE_LIST_API_REQUEST:
    return {
      ...state,
      errMsg: '',
      loading: true,
    };
  case types.SYMBOL_SUMMARY_PAGE_API_SUCCESS:
  case types.SYMBOL_SUMMARY_SYMBOL_DETAIL_SUCCESS:
  case types.PERFORMANCE_PAGE_API_SUCCESS:
  case types.ADJUSTMENT_PAGE_API_SUCCESS:
  case types.PREDICTION_PAGE_API_SUCCESS:
    return {
      ...state,
      errMsg: '',
      loading: false,
    };
  default:
    return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/appState.js